var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.40535 1.52588e-05C3.32206 1.52588e-05 0 3.32207 0 7.40531C0 11.4886 3.32206 14.8106 7.40535 14.8106C11.4886 14.8106 14.8106 11.4886 14.8106 7.40531C14.8106 3.32207 11.4886 1.52588e-05 7.40535 1.52588e-05ZM11.51 5.89656L6.78054 10.626C6.6366 10.77 6.4371 10.8526 6.23359 10.8526V11.1728L6.22671 10.8526C6.02048 10.8508 5.82018 10.7647 5.67703 10.6163L3.291 8.14315C2.99479 7.83616 3.0036 7.34577 3.31054 7.04956C3.45544 6.90961 3.64614 6.83275 3.8474 6.83275C4.05923 6.83275 4.25697 6.91667 4.40412 7.06907L6.24352 8.9756L10.4165 4.80281C10.5625 4.65679 10.7567 4.57625 10.9634 4.57625C11.1699 4.57625 11.3642 4.65663 11.5102 4.80265C11.8115 5.10431 11.8115 5.59506 11.51 5.89656Z",
    fill: "#66BB6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.57fd21035cb5dd00af0064a4d600c8f3.svg";
export { ForwardRef as ReactComponent };